import { useEffect, useState } from "react";
import useFirestore from "../common/useFirestore";

function useInquriyDetail(id){
    const [contact, setContact] = useState({
        title:"",
        company:"",
        email:"",
        register_at:"",
        tel:"",
        content:"",
        reply:"",
        file_list:[]
    });
    const {readFirestoreOneDoc} = useFirestore();

    useEffect(() => {
        getContact();
    }, [])

    const getContact = async() => {
        const contact = await readFirestoreOneDoc("Inquiry", id).then(res => {
            if(res.exists()){
                const data = res.data();
                const date = data.register_at.toDate();
                const register_at = `${date.getFullYear()}-${date.getMonth()+1}-${date.getDate()}`;
                return {
                    category:data.category,
                    register_at:register_at,
                    content:data.content,
                    file_list:data.file_list,
                    reply:data.reply || "",
                }
            }
        })
        setContact(contact);
    }

    return{contact}
}

export default useInquriyDetail;
